import React, {useEffect, useState} from "react";
import {useGlobalNotificationMessage} from "../context/message";
import Loading from "./loading";
import {CardElement, useElements, useStripe} from "@stripe/react-stripe-js";
import {useStripePayments} from "../context/stripe";
import HelperService from "../services/helper-service";
import {usePaymentService} from "../services/payment-service";
import {useAuth} from "../context/auth";

export default function StripePaymentMethods( props ){
    const [submitting, setSubmitting] = useState(false);
    const [userCards, setUserCards] = useState(null);
    const [showNewCard, setShowNewCard] = useState(false);
    const {addErrorMessage} = useGlobalNotificationMessage();
    const {stripePromise, initStripe} = useStripePayments();

    const stripe = useStripe();
    const elements = useElements();
    const ps = usePaymentService();
    const auth = useAuth();

    useEffect(() => {
        //get cards list
        reloadCards();
    }, []);

    function reloadCards(){
        ps.userCardsList(auth.currentUser.id).then(async (res) => {
            setUserCards(res);
        }).catch(error => {
            HelperService.handleApiErrors(error, addErrorMessage);
        });
    }

    //init strip
    useEffect(() => {
        if (showNewCard){
            ps.newUserCard(auth.currentUser.id).then(async (res) => {
                console.log(res);
                initStripe(res?.setupIntent?.client_secret);
            }).catch(error => {
                HelperService.handleApiErrors(error, addErrorMessage);
            });
        }
    }, [showNewCard]);

    const newCardSubmit = async (event) => {
        event.preventDefault();

        if (!stripe || !elements) {
            return;
        }
        setSubmitting(true);

        const cardElement = elements.getElement(CardElement);
        const {error, paymentMethod} = await stripe.createPaymentMethod({
            type: 'card',
            card: cardElement,
        });

        if (error) {
            HelperService.handleApiErrors(error, addErrorMessage);
            setSubmitting(false);
        } else {
            // send PaymentMethod to server and attach it to a customer.
            ps.saveUserCard(auth.currentUser.id, paymentMethod.id).then(async (res) => {
                reloadCards();
                setShowNewCard(false);
            }).catch(error => {
                HelperService.handleApiErrors(error, addErrorMessage);
            }).finally(()=>{
                setSubmitting(false);
            });
        }
    };

    const makePaymentMethodPrimary = (paymentMethod) => {
         setSubmitting(true);
        ps.setDefaultPaymentMethod(paymentMethod.id).then(async (res) => {
            reloadCards();
        }).catch(error => {
            HelperService.handleApiErrors(error, addErrorMessage);
        }).finally(()=>{
            setSubmitting(false);
        });
    };

    const removePaymentMethod = (paymentMethod) => {
         setSubmitting(true);
        ps.removePaymentMethod(paymentMethod.id).then(async (res) => {
            reloadCards();
        }).catch(error => {
            HelperService.handleApiErrors(error, addErrorMessage);
        }).finally(()=>{
            setSubmitting(false);
        });
    };

    const PaymentMethod = ({paymentMethod, customer=null}) => {
        return (<div className="d-flex gap-2 p-3">
            <div className="flex-grow-1">
                <h5>**** **** **** **** {paymentMethod.card.last4}</h5>
                <div className="d-flex gap-2">
                    <span>type: <span className="fw-bold">{paymentMethod.card.display_brand}</span></span>
                    <span>exp: <span className="fw-bold"><span>{paymentMethod.card.exp_month}</span>/<span>{paymentMethod.card.exp_year}</span></span></span>
                </div>
                {customer?.invoice_settings?.default_payment_method===paymentMethod.id && <div><span className="d-inline-block p-2 fs-7 rounded-2 bg-primary text-white mt-2">Primary card used for payments</span></div>}
            </div>
            <div className="flex-shrink-1 d-flex gap-2 text-end align-items-start">
                {customer?.invoice_settings?.default_payment_method!==paymentMethod.id && <button type="button" className="btn btn-sm btn-outline-primary" disabled={!!submitting} onClick={()=>makePaymentMethodPrimary(paymentMethod)}>Make primary</button>}
                <button type="button" className="btn btn-sm btn-outline-danger" disabled={!!submitting} onClick={()=>removePaymentMethod(paymentMethod)}>Remove</button>
            </div>
        </div>);
    }

    return (
        <>
            {!userCards && <div className="text-center py-5"><Loading /></div>}
            {userCards && userCards?.paymentMethods?.data?.length === 0 && <div className="text-center text-secondary">You have no payment methods added yet.</div> }
            {userCards && userCards?.paymentMethods?.data?.length > 0 &&
                <div>
                    {userCards?.paymentMethods?.data.map((paymentMethod, index) => (
                        <div key={paymentMethod.id} className="card my-2"><PaymentMethod paymentMethod={paymentMethod} customer={userCards.customer} /></div>
                    ))
                    }
                </div>
            }

            {!showNewCard && <div className="text-center text-secondary my-3">
                <button type="button" className="btn btn-outline-secondary" onClick={()=>{setShowNewCard(!showNewCard);}}>Add new payment method</button>
            </div>}

            {showNewCard && <div className="card rounded-3 shadow border-0 p-2 my-3">
                <div className="text-end"><button className="border-0 bg-white" onClick={()=>{setShowNewCard(!showNewCard);}}><span className="mdi mdi-close"></span></button> </div>
                {(!stripePromise) && <div className="text-center py-3"><Loading /></div> }
                {stripePromise &&
                    <form onSubmit={newCardSubmit}>
                        <div className="form-group my-3 p-3 rounded-2 bg-light">
                            <CardElement/>
                        </div>
                        <div className="form-group my-3 text-center">
                            <button type="submit" className="btn btn-primary" disabled={!stripe}>Add payment method</button>
                        </div>
                    </form>
                }
            </div>}
      </>
  )
}
